const API_URL = import.meta.env.VITE_API_URL
const GUEST_API = `${API_URL}${import.meta.env.VITE_GUEST_API_POSTFIX}`
const USER_API = `${API_URL}${import.meta.env.VITE_USER_API_POSTFIX}`
const MEDIATEKA_DOWNLOAD = `${API_URL}${import.meta.env.VITE_MEDIATEKA_DOWNLOAD_POSTFIX}`
const MEDIATEKA_UPLOAD =`${API_URL}${import.meta.env.VITE_MEDIATEKA_UPLOAD_POSTFIX}`

export { API_URL, GUEST_API, USER_API, MEDIATEKA_DOWNLOAD, MEDIATEKA_UPLOAD }
